export default __webpack_public_path__ + "assets/42cc2a3729b114c03b58878c7ae286e1.png";